import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { ProgressOutput } from 'libs/end-to-end/src/progress';
import { ProgressOutputFinalFile } from 'libs/end-to-end/src/progress';

export const ProgressCustomVizDefinition: CustomVizDefinition = {
  customVizId: 'progress',
  isDataQueuingAllowed: true,
  outputFileName: ProgressOutputFinalFile,
  outputSchema: ProgressOutput,
  resolveFocusArea: (customVizRequest) => {
    if (customVizRequest.customVizId !== 'progress') {
      throw new Error('Invalid custom viz ID');
    }
    return customVizRequest.inputs.extras.focusArea;
  },
  resolveFilters: (customVizRequest) => {
    if (customVizRequest.customVizId !== 'progress') {
      throw new Error('Invalid custom viz ID');
    }
    return customVizRequest.inputs.extras.filters;
  },
  resolveAnalysisName: () => undefined,
  checkEnoughDataStateEnabledGate: false,
  eventProperties: (request) => {
    if (request.customVizId !== 'progress') {
      throw new Error('Invalid custom viz ID');
    }
    return {
      'Custom Viz Type': request.customVizId,
      Filters: request.inputs.extras.filters,
      'Selected Dimensions': [request.inputs.extras.focusArea],
      'Selected Metrics': [request.inputs.extras.metric],
      'Selected Focus Areas': [request.inputs.extras.focusArea],
    };
  },
  getUrlPath: () => 'progress/disparities',
};
